// axiosBaseQuery.ts (or .js if using JavaScript)
import axios from "axios";
 
 
export const URLOPTIONS = {
  // API:
  //   window.location?.hostname === "localhost"
  //     ? "http://localhost:8899"
  //     : "https://api-dev.nouee.com",

  API:
    window.location?.hostname === "localhost"
      // ? "http://localhost:8899"
      ? "https://api.nouee.com"
      : window.location?.hostname === "dev.nouee.com"
      ? "https://api-dev.nouee.com"
      : "https://api.nouee.com",
};
export const commonExtendedApi = "/v1";
 
export const BaseURL = URLOPTIONS.API + commonExtendedApi;
 
// Create Axios instance with interceptors
const createAxiosInstance = (baseUrl, customToken) => {
  const instance = axios.create({ baseURL: baseUrl });
 
  // Request Interceptor
  instance.interceptors.request.use(
    (config) => {
      // Example: Attach Authorization token
      const token = customToken || localStorage.getItem("hrms_token") || localStorage.getItem("hrms_admin_token");
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
 
      return config;
    },
    (error) => Promise.reject(error)
  );
 
  // Response Interceptor
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Handle specific errors globally
      if (error.response?.status === 401) {
        console.error("Unauthorized! Redirecting to login...");
        // Handle 401 error: Example: redirect to login
        // window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
 
  return instance;
};
 
const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, method = "GET", data, params, headers, customToken }) => {
    const axiosInstance = createAxiosInstance(baseUrl, customToken); // Use Axios instance with interceptors
 
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
      });
    const temp ={...result?.data,statusCode:result?.status}
      return { data:temp};
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
 
const globalApi = axiosBaseQuery({ baseUrl: BaseURL });
export default globalApi;
 
 